<template>
  <div class="d-flex text-center border-bottom-bloco py-2">
    <InputFormatadorDeValor
      v-model="linha.sugestao_compra_em_quantidade"
      :removerValorIrrelevante="true"
      centralizar
      class="font-12"
      :sufixo="linha.unidade_compra"
      :disabled="data_table_departamentos_carregando_dados"
      @focus="$event.target.select()"
      @blur="salvarEdicaoSugestao"
      @keyup.enter="$event.target.blur()"
      @keydown.prevent.up="incrementarSugestao"
      @keydown.prevent.down="decrementarSugestao"
      @change="sugestao_alterada = true"
    />

    <ValidaLoteMinimo
      v-if="!LOTE_MINIMO_VALIDO && linha.sugestao_compra_em_quantidade > 0"
      v-model="linha.sugestao_compra_em_quantidade"
      :lote-minimo="linha.lote_minimo"
      @change="sugestao_alterada = true;salvarEdicaoSugestao();"
    />

    <v-tooltip v-if="linha.sugestao_compra_em_quantidade <= 0" bottom>
      <template v-slot:activator="{on, attrs}">
        <v-btn icon small color="red" v-bind="attrs" v-on="on">
          <v-icon>mdi-alert</v-icon>
        </v-btn>
      </template>
      <span>Quantidade de compra inválida</span>
    </v-tooltip>
  </div>
</template>

<script>
import InputFormatadorDeValor from "../../../../utils/InputFormatadorDeValor.vue";
import ValidaLoteMinimo from "../../../ValidaLoteMinimo.vue";

import {editarCategoriaNoPedido} from "../../../../../api/compraPorDepartamentos/ProdutosPedidoCompraTipo.js";

import {NIVEIS_DE_EXPANCAO} from "../../../../utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao.js";
import {data_table_departamentos_carregando_dados} from "../../../../utils/dataTable/sysDataTableDepartamentos/CarregandoDados.js";
import {parametros_rota} from "../../helpers/ParametrosRota.js";

export default {
  name: "SugestaoDeCompra",
  mixins: [data_table_departamentos_carregando_dados, parametros_rota],
  components: {
    ValidaLoteMinimo,
    InputFormatadorDeValor
  },
  props: {
    linha: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    NIVEIS_DE_EXPANCAO,
    sugestao_alterada: false
  }),
  computed: {
    LOTE_MINIMO_VALIDO() {
      if (!this.linha.lote_minimo) return false;

      const qtd_compra = this.linha.sugestao_compra_em_quantidade.toFixed(4);
      const modulo = Number((qtd_compra % this.linha.lote_minimo).toFixed(4));

      return (modulo == 0 || modulo == this.linha.lote_minimo);
    }
  },
  methods: {
    salvarEdicaoSugestao() {
      if (!this.sugestao_alterada || !this.LOTE_MINIMO_VALIDO || this.linha.sugestao_compra_em_quantidade <= 0) return;

      const categoria = {
        idcategoria: this.linha.idcategoria,
        id_pedido: this.linha.id_pedido,
        quantidade: this.linha.sugestao_compra_em_quantidade
      };

      this.$store.dispatch("loading/addRequisicao",
        editarCategoriaNoPedido(categoria).then(this.salvoComSucesso));
    },
    salvoComSucesso() {
      this.sugestao_alterada = false;
    },
    incrementarSugestao() {
      this.linha.sugestao_compra_em_quantidade++;
    },
    decrementarSugestao() {
      this.linha.sugestao_compra_em_quantidade--;
    }
  }
}
</script>

<style scoped>
.border-bottom-bloco {
  border-bottom: 1px solid #A9A9A9;
}
</style>
